<template>
    <span
        @click.prevent="addModelToFavouritesAndOpenModal(id)"
        class="w-1/3 flex flex-col gap-2 border-l border-greyTan items-center justify-center cursor-pointer"
    >
        <svg
            :class="{
                'added-to-favourites': idArray.includes(id),
            }"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="heart"
            class="w-7 svg-inline--fa fa-heart fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-10 0 532 512"
        >
            <path
                stroke="#D4CFC9"
                stroke-width="20"
                fill="white"
                d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
            ></path>
        </svg>
        <div class="text-greyTan text-xs">
            <span
                class="text-red font-semibold text-center"
                v-if="idArray.includes(id)"
            >
                ADDED!
            </span>
            <span v-else>FAVOURITES</span>
        </div>
    </span>
    <Favouritesmodal
        v-show="isModalOpen"
        @closeModal="isModalOpen = false"
        :title="title"
        :image="image"
    ></Favouritesmodal>
</template>

<script>
import { ref, toRefs } from "vue";
import FavouritesState, { addModelToFavourites } from "./favourites/State";
import Favouritesmodal from "./Favouritesmodal.vue";

export default {
    props: {
        id: Number,
        title: String,
        image: String,
    },
    setup(props) {
        const { idArray } = toRefs(FavouritesState);
        const isModalOpen = ref(false);

        function addModelToFavouritesAndOpenModal(id) {
            if (!idArray.value.includes(id)) {
                isModalOpen.value = true;
            }
            addModelToFavourites(id);
        }
        return {
            addModelToFavouritesAndOpenModal,
            addModelToFavourites,
            idArray,
            isModalOpen,
        };
    },
    components: { Favouritesmodal },
};
</script>
